<template>
  <div class="base-select-tree">
    <el-select
      ref="baseSelectTree"
      v-model="selectValue"
      class="select-tree"
      name="option 1"
      :clearable="clearable"
      filterable
      :multiple="showCheckbox"
      :collapse-tags="showCheckbox"
      :filter-method="filterMethod"
      @focus="filterMethod('')"
      @change="handleSelectChange"
      @remove-tag="handleRemoveTag"
    >
      <el-option
        v-for="(item, index) in optionData(sourceData)"
        :key=" index"
        :label="item.label"
        :value="item.value"
        style="display: none;"
      />
      <el-tree
        ref="selectTree"
        class="select-tree"
        :data="sourceData"
        :props="treeDefaultProps"
        :node-key="treeDefaultProps.value"
        highlight-current
        :expand-on-click-node="false"
        default-expand-all
        :show-checkbox="showCheckbox"
        :check-strictly="checkStrictly"
        :check-on-click-node="checkOnClickNode"
        :filter-node-method="filterNode"
        v-bind="treeAttrs"
        @node-click="handleNodeClick"
        @check="handleCheck"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'BaseSelectTree',
  model: {
    event: 'change'
  },
  props: {
    treeDefaultProps: {
      type: Object,
      default: () => ({
        children: 'children',
        label: 'name',
        value: 'id'
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    checkOnClickNode: {
      type: Boolean,
      default: false
    },
    treeAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectValue: '',
      checkedNodes: []
    }
  },
  computed: {
    sourceData() {
      return this.options
    }
  },
  watch: {
    value(v) {
      this.selectValue = v
      if (Array.isArray(v) && v.length === 0) {
        this.$refs.selectTree.setCheckedKeys(v)
      }
    }
  },
  created() {
    this.selectValue = this.value
  },
  methods: {
    filterMethod(value) {
      this.$refs.selectTree.filter(value)
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.treeDefaultProps.label].indexOf(value) !== -1
    },
    /**
     * 树形转平面的迭代方法
     * option 1的el-option需要此方法绑定数据
     */
    optionData(array, result = []) {
      array.forEach(item => {
        result.push({ label: item[this.treeDefaultProps.label], value: item[this.treeDefaultProps.value] })
        if (item.children && item.children.length !== 0) {
          this.optionData(item.children, result)
        }
      })
      return JSON.parse(JSON.stringify(result))
    },

    // 点击节点的响应
    handleNodeClick(node) {
      // 当前节点的数据有包含disabled属性时，不触发事件
      if (node.disabled) {
        return
      }
      this.selectValue = node[this.treeDefaultProps.label]
      this.$refs.baseSelectTree.blur()
      this.$emit('change', node[this.treeDefaultProps.label])
      this.$emit('node-click', node)
    },
    // 复选框勾选时触发
    handleCheck(node, data) {
      const { checkedNodes } = data
      this.checkedNodes = JSON.parse(JSON.stringify(checkedNodes))
      this.selectValue = checkedNodes.map(item => item[this.treeDefaultProps.label])
      this.$emit('change', this.selectValue)
      this.$emit('node-check', checkedNodes)
    },
    // 选择框改变时触发
    handleSelectChange(value) {
      this.selectValue = value
      this.$emit('change', value)
      this.$emit('node-click', {})
    },
    handleRemoveTag(value) {
      this.checkedNodes = this.checkedNodes.filter(item => item[this.treeDefaultProps.label] !== value)
      this.$refs.selectTree.setCheckedNodes(this.checkedNodes)
      this.$emit('node-check', this.checkedNodes)
    }
  }
}
</script>
<style lang="scss" scoped></style>
